import { createRouter, createWebHistory } from "vue-router";
import Top from "../components/TopPage.vue";
import About from "../components/AboutPage.vue";
import Access from "../components/AccessPage.vue";
//import Event from "../components/EventPage.vue";

const routes = [
  {
    path: "/",
    name: "Top",
    component: Top,
  },
  {
    path: "/exhibit",
    name: "exhibit",
    component: About,
  },
  // {
  //   path: "/event",
  //   name: "Event",
  //   component: Event,
  // },
  {
    path: "/access",
    name: "Access",
    component: Access,
  },
];

const router = createRouter({
  //history: createWebHistory("/"),
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
